import { Action } from '@ngrx/store';
import { ProtocolTypeModel } from '../../../_sdk/ems-devices/protocol-type.model';
import { ModelCollection } from '../../../_sdk/collection.model';

export const LOAD = 'PROTOCOL_TYPE_LOAD';
export const LOAD_COMPLETE = 'PROTOCOL_TYPE_LOAD_COMPLETE';

export const INSERT = 'PROTOCOL_TYPE_INSERT';
export const INSERT_COMPLETE = 'PROTOCOL_TYPE_INSERT_COMPLETE';

export const UPDATE = 'PROTOCOL_TYPE_UPDATE';
export const UPDATE_COMPLETE = 'PROTOCOL_TYPE_UPDATE_COMPLETE';

export const DELETE = 'PROTOCOL_TYPE_DELETE';
export const DELETE_COMPLETE = 'PROTOCOL_TYPE_DELETE_COMPLETE';

export const DISPOSE = 'PROTOCOL_TYPE_DISPOSE';

export class Load implements Action {
    public readonly type = LOAD;
}

export class LoadComplete implements Action {
    public readonly type = LOAD_COMPLETE;

    constructor(public payload: ModelCollection<ProtocolTypeModel>) { }
}

export class Insert implements Action {
    public readonly type = INSERT;

    constructor(public payload: ProtocolTypeModel) { }
}

export class InsertComplete implements Action {
    public readonly type = INSERT_COMPLETE;

    constructor(public payload: ProtocolTypeModel) { }
}

export class Update implements Action {
    public readonly type = UPDATE;

    constructor(public payload: ProtocolTypeModel) { }
}

export class UpdateComplete implements Action {
    public readonly type = UPDATE_COMPLETE;

    constructor(public payload: ProtocolTypeModel) { }
}

export class Delete implements Action {
    public readonly type = DELETE;

    constructor(public payload: ProtocolTypeModel) { }
}

export class DeleteComplete implements Action {
    public readonly type = DELETE_COMPLETE;

    constructor(public payload: ProtocolTypeModel) { }
}

export class Dispose implements Action {
    public readonly type = DISPOSE;
}

export type Actions =
    Load | LoadComplete
    | Insert | InsertComplete
    | Update | UpdateComplete
    | Delete | DeleteComplete
    | Dispose;
